import React, { useState } from "react";

import { Route, Routes, useLocation } from "react-router-dom";

// core components
import Footer from "../components/Footer";

import routes from "../routesCondicionesReservar";

import PageLayout from "../components/LayoutContainers/PageLayout";

import { Helmet } from 'react-helmet'

import MDBox from "../components/MDBox";

import error from "../assets/img/clint-mckoy.jpg";
import reservas from "../assets/img/reserva1.jpg";

import OthelloCookieConsent from "../componentsothello/OthelloCookieConsent";

function LayoutCondicionesReservar() {

    const { search } = useLocation();

    /*React.useEffect(() => {

        /*  let url = search;
          let params = new URLSearchParams(url);
          let idconexion = "";
  
          if (params.has('ID'))
              idconexion = params.get('ID').split('-')[0];
  
          setidconexion(idconexion);
        setLoading(false);

    }, [loading]);*/


    /*getBgImage = () => {

        if (window.location.pathname.indexOf("/formulario/encuesta") !== -1)
            return encuesta;
        else if (window.location.pathname.indexOf("/formulario/error") !== -1)
            return error;
    };*/

    const getRoutes = (allRoutes) => {
        return allRoutes.map((route) => {
            //si es un item collapse hacemos route de los hijos
            if (route.collapse)
                return getRoutes(route.collapse);

            if (route.route) {
                return <Route path={route.path} element={route.component} key={route.key} />;
            }

            return null;
        });
    }

    return (
        <PageLayout>
            <Helmet>
                <title>Condiciones Reservar</title>
            </Helmet>
            <Routes>
                {getRoutes(routes)}
            </Routes>
            <MDBox mt={4}>
                <Footer white contacto={false} />
            </MDBox>
            <OthelloCookieConsent />
        </PageLayout>);
}


export default LayoutCondicionesReservar;